










import { computed, defineComponent } from "@vue/composition-api";
import { format, parse } from "date-fns/esm";

interface Props {
  value?: Date;
  minimum?: Date;
}

const FORMAT_STRING = "yyyy-MM-dd";

export default defineComponent<Props>({
  name: "DateInput",
  props: {
    value: { type: Date, required: false },
    minimum: { type: Date, required: false }
  },
  setup(props: Props, context) {
    const formatted = computed(() =>
      props.value ? format(props.value, FORMAT_STRING) : null
    );

    const emit = (value: string) =>
      context.emit(
        "input",
        value ? parse(value, FORMAT_STRING, new Date()) : null
      );

    return {
      formatted,
      format: (value: Date) => format(value, FORMAT_STRING),
      emit
    };
  }
});
